// noinspection JSUnresolvedReference

(function(app) {
    const elements = {};

    app.MirroredToggle = {
        init() {
            elements.mirroredToggleEl = document.querySelector('.wdpp-checkbox--mirrored');
            elements.mirroredDisplayEl = document.querySelector('.wdpp-display--mirrored');
            
            // Validate required elements
            if (!app.Utils.validateElements('mirrored inputs', {
                'mirrored toggle checkbox': '.wdpp-checkbox--mirrored',
                'mirrored display element': '.wdpp-display--mirrored'
            })) {
                return;
            }

            elements.mirroredToggleEl.addEventListener('change', () => {
                app.Store.setState('mirrored', elements.mirroredToggleEl.checked);
            });

            app.Store.subscribe('initialized', () => {
                app.Store.setState('mirrored', elements.mirroredToggleEl.checked);
            });

            // Subscribe to store changes
            app.Store.subscribe('mirrored', (value) => this.updateMirroredDisplay(value));
        },

        updateMirroredDisplay(isChecked) {
            if (elements.mirroredDisplayEl) {
                elements.mirroredDisplayEl.textContent = isChecked ? 'Ja' : 'Nej';
                elements.mirroredDisplayEl.classList.toggle('is-true', isChecked);
                elements.mirroredDisplayEl.classList.toggle('is-false', !isChecked);
            }
        },
        
        /**
         * Get the mirrored data for cart export
         * @returns {object} The mirrored data for the cart
         */
        getCartData() {
            return {
                mirrored: app.Store.getState('mirrored') || false,
            };
        },

        /**
         * Get the mirrored data for price calculation
         * @returns {object} The mirrored data for the price
         */
        getPriceData() {
            return {
                mirrored: app.Store.getState('mirrored') || false,
            };
        }
    };
})(window.app = window.app || {});